import React, { useState, useEffect } from 'react';
import './FloatingChatButton.css';

function FloatingChatButton({ onOpen, isVisible = true }) {
  const [isHovered, setIsHovered] = useState(false);
  const [hasNewMessage, setHasNewMessage] = useState(false);

  // Animation effect for pulse
  useEffect(() => {
    const timer = setInterval(() => {
      setHasNewMessage(prev => !prev);
    }, 2000);

    return () => clearInterval(timer);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="floating-chat-button-container">
      <button
        className={`floating-chat-button ${isHovered ? 'hovered' : ''} ${hasNewMessage ? 'pulse' : ''}`}
        onClick={onOpen}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        title="Chat with us!"
      >
        <span className="chat-icon">💬</span>
        <span className="chat-text">Chat</span>
      </button>

      {isHovered && (
        <div className="floating-chat-tooltip">
          <p>Need help? Ask our AI chatbot about our products and services!</p>
        </div>
      )}

      <div className="floating-chat-pulse"></div>
    </div>
  );
}

export default FloatingChatButton;
